import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';

import ClientBrandingPageComponent from './ClientBrandingPage';
import { getFacilityBranding, createFacilityBranding, updateFacilityBranding } from '../../store/actions/clients.js';
import { selectSelectedClient } from '../../store/selectors/clients';
import { selectSessionUserClientId } from '../../store/selectors/session';
import { get } from '../../store/actions/brand';
import { getPricerConfigContracts } from '../../store/actions/pricers';
import { getTinyContractsByState } from "../../store/actions/contracts.js";
import { selectTinyContractsByState } from '../../store/selectors/contracts';


export const ClientBrandingPage = connect(
    () => {

        const selectBranding = (state) => state.clients.facilityBranding;
        const selectBrand = (state) => state.brand.data;
        const selectTinyContracts = selectTinyContractsByState;
        const selectClientId = createSelector(
            selectSelectedClient,
            selectSessionUserClientId,
            (selectedClientId, sessionClientId) => {
                return selectedClientId ?? sessionClientId
            }
        );

        const selectInitialValues = createSelector(
            selectBranding,
            selectTinyContracts,
            (branding, tinyContracts) => {
                const normalizeLogoPath = (path) => {
                    if (!path) return '';
                    return path.startsWith('/') || path.startsWith('http') ? path : `/${path}`;
                };
                const brandingId = branding?.brandingId;
                if (branding && brandingId) {
                    return {
                        id: brandingId,
                        facilityName: branding.facilityName,
                        logo: null,
                        logoPath: normalizeLogoPath(branding.logoPath),
                        usePricerLogo: branding.usePricerLogo,
                        signatureLabels:
                            branding.signatureLabelList && branding.signatureLabelList.length > 0
                                ? branding.signatureLabelList
                                : [''],
                        outpatientDisclaimer: branding.outpatientDisclaimer || "",
                        professionalDisclaimer: branding.professionalDisclaimer || "",
                        inpatientDisclaimer: branding.inpatientDisclaimer || "",
                        pricerBucket: branding.pricerBucket,

                        isPromptPayEnabled: branding.isPromptPayEnabled ?? false,
                        isSelfPayEnabled: branding.isSelfPayEnabled ?? false,
                        promptPayPercentage: branding.promptPayPercentage ?? null,
                        promptPayDays: branding.promptPayDays ?? null,

                        selfPayMode: branding.selfPayContractId ? 'contract' : 'percentage',
                        selfPayContract: branding.selfPayContractId
                            ? tinyContracts?.find(
                                (c) => c.id === branding.selfPayContractId
                              ) || null
                            : null,

                        selfPayPercentage: branding.selfPayPercentage ?? null,
                    };
                }

                return {
                    id: '',
                    facilityName: branding?.facilityName || '',
                    logo: null,
                    logoPath: '',
                    usePricerLogo: false,
                    signatureLabels: [''],
                    outpatientDisclaimer: "",
                    professionalDisclaimer: "",
                    inpatientDisclaimer: "",
                    pricerBucket: branding ? branding.pricerBucket : '',

                    isPromptPayEnabled: false,
                    isSelfPayEnabled: false,
                    promptPayPercentage: null,
                    promptPayDays: null,

                    selfPayMode: 'contract',
                    selfPayContract: null,
                    selfPayPercentage: null,
                };
            }
        );

        return (state, props) => {
            const facilityId = props?.match?.params?.facilityId;
            return {
                facilityId: facilityId ? parseInt(facilityId) : null,
                brand: selectBrand(state, props),
                initialValues: selectInitialValues(state, props),
                clientId: selectClientId(state),
                getBrandingPending: state.clients.getFacilityBranding.pending,
                createBrandingPending: state.clients.createFacilityBranding.pending,
                updateBrandingPending: state.clients.updateFacilityBranding.pending,
                pricerPayerContracts: state.pricers.contracts,
                tinyContracts: selectTinyContracts(state),
            }
        };
    },
    (dispatch) => ({
        actions: bindActionCreators({
            getFacilityBranding,
            getBrand: get,
            createFacilityBranding,
            updateFacilityBranding,
            getPricerPayerContractsTiny: getPricerConfigContracts,
            getTinyContractsByState: getTinyContractsByState,
        }, dispatch)
    })
)(injectIntl(ClientBrandingPageComponent));
